module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-bread-crumb', {
    attrs: {
      "bread-cumb": _vm.breadCrumb
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "formRef",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "activity_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "maxlength": 500
    },
    model: {
      value: (_vm.form.activity_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "activity_name", $$v)
      },
      expression: "form.activity_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动店铺",
      "prop": "shop_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.shop_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "shop_id", $$v)
      },
      expression: "form.shop_id"
    }
  }, _vm._l((_vm.shops), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间",
      "prop": "time"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetimerange",
      "value-format": "yyyy-MM-dd HH:mm",
      "format": "yyyy-MM-dd HH:mm",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.form.time),
      callback: function($$v) {
        _vm.$set(_vm.form, "time", $$v)
      },
      expression: "form.time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动简介",
      "prop": "brief"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "maxlength": 500
    },
    model: {
      value: (_vm.form.brief),
      callback: function($$v) {
        _vm.$set(_vm.form, "brief", $$v)
      },
      expression: "form.brief"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动介绍",
      "prop": "intro"
    }
  }, [_c('quill-editor', {
    ref: "editor",
    on: {
      "change": _vm.onIntroChange
    },
    model: {
      value: (_vm.form.intro),
      callback: function($$v) {
        _vm.$set(_vm.form, "intro", $$v)
      },
      expression: "form.intro"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动人数",
      "prop": "number"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 0,
      "max": 99999999,
      "min": 1
    },
    model: {
      value: (_vm.form.number),
      callback: function($$v) {
        _vm.$set(_vm.form, "number", $$v)
      },
      expression: "form.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('preview', {
    attrs: {
      "data": _vm.form.intro
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad6dcacc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/activity/activityForm.vue
// module id = 941
// module chunks = 0